import type { RefreshInfo, RefreshResult, RefreshCard } from './api'

export const WEB_UNCHECKED_MESSAGE = 'Tick off every flagged fact first'
export const REFRESH_EDIT_OPEN = 'This page already has an edit open. Finish or discard it first.'
export const REFRESH_RUNNING = 'A draft is already being written for this title. Try again when it is done.'

const n = (v: number) => v.toLocaleString('en-US')
const count = (v: number, one: string) => `${n(v)} ${one}${v === 1 ? '' : 's'}`

/** "Position 9.2 · 12,400 impressions · 85 clicks · about 520 more clicks a month in the top 3" */
export function upsideLine(c: Pick<RefreshCard, 'position' | 'impressions' | 'clicks' | 'upside'>): string {
  return `Position ${c.position.toFixed(1)} · ${count(c.impressions, 'impression')} · ${count(c.clicks, 'click')} · about ${n(c.upside)} more clicks a month in the top 3`
}

/** Save and publish waits until every web-only fact is ticked. A draft that is not a refresh never waits. */
export function canPublishRefresh(refresh: Pick<RefreshInfo, 'web_passages'> | null | undefined): boolean {
  return !refresh || refresh.web_passages.every((p) => !!p.checked_by)
}

const pos = (p: number | null | undefined) => (p == null ? '—' : p.toFixed(1))
const clicks = (c: number | null | undefined) => (c == null ? '—' : n(c))

/** "too early — Google needs 2–8 weeks" or "position 9.2 → 4.1 · clicks 85 → 240" */
export function resultLine(r: Pick<RefreshResult, 'status' | 'before' | 'after'>): string {
  if (r.status === 'too_early' || !r.after) return 'too early — Google needs 2–8 weeks'
  return `position ${pos(r.before?.position)} → ${pos(r.after.position)} · clicks ${clicks(r.before?.clicks)} → ${clicks(r.after.clicks)}`
}
